import axios from "axios";
import changeUrl from "./changeUrl";
import VueCookies from "vue-cookies";
const instance = axios.create({
  timeout: 15000 //请求超时
});
// 设置请求拦截
instance.interceptors.request.use(
  config => {
    config.url = changeUrl(config.url);
    config.headers = config.headers || {};
    config.headers = {
      ...config.headers,
      SystemPaaS: 6,
      PaaSPort: 1,
      codeType:sessionStorage.getItem('codeType')||3,
      token: VueCookies.get("token")
    };
    // config.headers["X-EICCHANNEL-TOKEN"] = "gk_" + token;
    return config;
  },
  err => {
    throw new Error(err);
  }
);
export default instance;



// WEBPACK FOOTER //
// ./src/api/resetAxios.js